import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, show, onClose, onConfirm, title, message, notes, confirmText = 'Confirm', cancelText = 'Cancel', type = 'warning' }) => {
  // Support both 'isOpen' and 'show' props for compatibility
  const isVisible = isOpen !== undefined ? isOpen : show;
  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return '⚠';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '⚠';
    }
  };

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <div className={`confirmation-modal-icon confirmation-modal-icon-${type}`}>
          {getIcon()}
        </div>
        <div className="confirmation-modal-content">
          <h3 className="confirmation-modal-title">{title}</h3>
          <p className="confirmation-modal-message">{message}</p>
          {notes && (
            <div className="confirmation-modal-notes">
              <span className="confirmation-modal-notes-label">Notes:</span>
              <span className="confirmation-modal-notes-text">{notes}</span>
            </div>
          )}
        </div>
        <div className="confirmation-modal-actions">
          <button className="confirmation-modal-button confirmation-modal-button-cancel" onClick={onClose}>
            {cancelText}
          </button>
          <button className={`confirmation-modal-button confirmation-modal-button-${type}`} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
